/* eslint-disable max-lines */
import {
    ChatAlt2Icon,
    DocumentTextIcon,
    DotsVerticalIcon,
    FingerPrintIcon,
    FlagIcon,
    HeroNoCircleIcon,
    NinchatSidebarIcon,
    NinchatTransferChatIcon,
    VideoCameraIcon,
    XIcon,
} from '../../Icon'
import {
    Dropdown,
    DropdownButtonNew as DropdownButton,
    DropdownContent,
} from '../../Dropdown'
import {
    styledActionContainer,
    styledActions,
} from '../styles/Menubar'
import {AudienceMenubarViewProps} from './types'
import Button from '../../Button'
import ConfirmationPromiseModal from 'components/Modal/ConfirmationPromiseModal'
import {Icon} from 'components/Icon/types'
import MenubarName from '../MenubarName'
import React from 'react'

import permissionGuard from 'components/Navigation/helpers/PermissionGuard'
import {styled} from '../../../stitches/config'
import {styledItem} from 'components/Dropdown/styles'
import {usePromiseModal} from 'components/Modal/PromiseModal/hooks/usePromiseModal'
import {useTranslation} from 'react-i18next'

const StyledActionContainer = styled('div', styledActionContainer)
const StyledActions = styled('div', styledActions)
const StyledItem = styled('div', styledItem)

const AudienceMenubarView = (props: AudienceMenubarViewProps): React.ReactElement => {
    const {t} = useTranslation()
    const openConfirmationPromiseModal = usePromiseModal(ConfirmationPromiseModal)


    const {
        audienceRegistration,
        hasChannelPermission,
        chat,
        closeConversationModal,
        endConversationModal,
        hasUnreadMessages,
        isActiveVideoChannel,
        isChannelClosed,
        isChannelSidebarOpen,
        isChannelSuspended,
        isScheduledAppointmentChannel,
        isVideoChannel,
        loadTranscript,
        onBlockIpAddress,
        onRequestAuthentication,
        onToggleChannelSidebar,
        onToggleChat,
        onToggleVideo,
        queueSso,
        transferConversationModal,
    } = props

    const hasViewRealmTranscriptPermissions = permissionGuard.hasViewRealmTranscriptPermissions() || permissionGuard.hasManageRealmChannelPermissions(chat.channel_id || '')

    const blockIpAddress = () => {
        openConfirmationPromiseModal({
            text: t('Are you sure you wish to temporarily block visitors IP address?'),
            title: t('Block IP address'),
        }).then(() => {
            onBlockIpAddress()
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        }, () => {})
    }

    const hpa = queueSso && queueSso[Object.keys(queueSso)[0]]?.hpa

    return (
        <>
            <MenubarName
                chat={chat}
                isChannelSidebarOpen={isChannelSidebarOpen}
                onToggleChannelSidebar={onToggleChannelSidebar}
            />
            <StyledActionContainer>
                <StyledActions>
                    {!!queueSso &&
                        <Dropdown>
                            <DropdownButton
                                caret={false}
                                color='text'
                                iconRight={FingerPrintIcon}
                                title={t('Request authentication')}
                            />
                            <DropdownContent direction='right'>
                                <StyledItem>
                                    <Button
                                        color='text'
                                        disabled={isChannelClosed}
                                        iconLeft={FingerPrintIcon}
                                        onPress={() => { onRequestAuthentication() }}
                                        text={t('Request authentication')}
                                        title={t('Request authentication')}
                                    />
                                </StyledItem>
                                {!!hpa &&
                                    <StyledItem>
                                        <Button
                                            color='text'
                                            disabled={isChannelClosed}
                                            iconLeft={FingerPrintIcon}
                                            onPress={() => { onRequestAuthentication(true) }}
                                            text={t('Request authentication as delegate')}
                                            title={t('Request authentication as delegate')}
                                        />
                                    </StyledItem>}
                            </DropdownContent>
                        </Dropdown>}
                    {!!hasChannelPermission &&
                        <Button
                            color='text'
                            disabled={isChannelSuspended}
                            iconLeft={VideoCameraIcon}
                            onPress={onToggleVideo}
                            title={isVideoChannel ? t('Disable video') : t('Enable video')}
                        />}
                    <Dropdown>
                        <DropdownButton caret={false} color='text' iconRight={DotsVerticalIcon} />
                        <DropdownContent direction='right'>
                            {!!queueSso &&
                                <>
                                    <StyledItem>
                                        <Button
                                            color='text'
                                            disabled={isChannelClosed}
                                            iconLeft={FingerPrintIcon}
                                            onPress={() => { onRequestAuthentication() }}
                                            text={t('Request authentication')}
                                            title={t('Request authentication')}
                                        />
                                    </StyledItem>
                                    {!!hpa &&
                                        <StyledItem>
                                            <Button
                                                color='text'
                                                disabled={isChannelClosed}
                                                iconLeft={FingerPrintIcon}
                                                onPress={() => { onRequestAuthentication(true) }}
                                                text={t('Request authentication as delegate')}
                                                title={t('Request authentication as delegate')}
                                            />
                                        </StyledItem>}
                                </>}
                            {/* Hide transfer option for scheduled appointments */}
                            {!isScheduledAppointmentChannel && !!hasViewRealmTranscriptPermissions &&
                                <StyledItem>
                                    <Button
                                        color='text'
                                        iconLeft={DocumentTextIcon}
                                        onPress={() => { loadTranscript() }}
                                        text={t('Show transcript')}
                                        title={t('Show transcript')}
                                    />
                                </StyledItem>}
                            <StyledItem>
                                <Button
                                    color='text'
                                    disabled={isChannelClosed}
                                    iconLeft={NinchatTransferChatIcon}
                                    onPress={() => { transferConversationModal() }}
                                    text={t('Transfer conversation')}
                                    title={t('Transfer conversation')}
                                />
                            </StyledItem>
                            {!!audienceRegistration &&
                                <StyledItem>
                                    <Button
                                        color='text'
                                        disabled={!audienceRegistration}
                                        iconLeft={HeroNoCircleIcon as unknown as Icon}
                                        onPress={() => { blockIpAddress() }}
                                        text={t('Block IP address')}
                                        title={t('Block IP address temporarily')}
                                    />
                                </StyledItem>}
                            <hr />
                            {!!isChannelClosed &&
                                <StyledItem>
                                    <Button
                                        color='text'
                                        iconLeft={XIcon}
                                        onPress={() => { closeConversationModal() }}
                                        text={t('Close conversation')}
                                        title={t('Close conversation')}
                                    />
                                </StyledItem>}
                            {!isChannelClosed &&
                                <StyledItem>
                                    <Button
                                        color='text'
                                        iconLeft={FlagIcon}
                                        onPress={() => { endConversationModal() }}
                                        text={t('End conversation')}
                                        title={t('End conversation')}
                                    />
                                </StyledItem>}
                        </DropdownContent>
                    </Dropdown>
                    {!!isActiveVideoChannel &&
                        <Button
                            color={hasUnreadMessages ? 'highlight' : 'text'}
                            iconLeft={ChatAlt2Icon}
                            onPress={() => { onToggleChat() }}
                            title={t('Toggle chat')}
                        />}
                    {!isChannelClosed &&
                        <Button onPress={endConversationModal} text={t('End conversation')} />}
                    {!!isChannelClosed &&
                        <Button onPress={closeConversationModal} text={t('Close conversation')} />}
                    {!isChannelSidebarOpen &&
                        <Button
                            color='text'
                            iconLeft={NinchatSidebarIcon}
                            onPress={() => { onToggleChannelSidebar() }}
                            title={t('Show audience info')}
                        />}
                </StyledActions>
            </StyledActionContainer>
        </>
    )
}

export default AudienceMenubarView
